import React from 'react';
import { IS_DEMO, PERSONAS, getPersona, switchPersona, type PersonaId } from '@/lib/demo';

/** Demo-only pill: "Demo · Mujer | Hombre". Renders nothing outside the demo build. */
export const DemoPersonaSwitch: React.FC = () => {
  if (!IS_DEMO) return null;
  const current = getPersona().id;
  return (
    <div
      role="radiogroup"
      aria-label="Perfil de demostración"
      style={{
        position: 'absolute', top: 16, left: '50%', transform: 'translateX(-50%)', zIndex: 20,
        display: 'inline-flex', alignItems: 'center', gap: 2, padding: 2,
        borderRadius: 999, border: '1px solid var(--c-line)', background: 'var(--c-surface)',
        backdropFilter: 'blur(10px)', WebkitBackdropFilter: 'blur(10px)',
        fontFamily: 'var(--ff-body)', fontSize: 10, fontWeight: 600, letterSpacing: '0.12em', textTransform: 'uppercase',
      }}
    >
      <span style={{ padding: '0 8px', color: 'var(--c-crimson)' }}>Demo</span>
      {(Object.keys(PERSONAS) as PersonaId[]).map((id) => {
        const on = id === current;
        return (
          <button
            key={id}
            type="button"
            role="radio"
            aria-checked={on}
            onClick={() => !on && switchPersona(id)}
            style={{
              padding: '5px 10px', borderRadius: 999, border: 'none', cursor: on ? 'default' : 'pointer',
              background: on ? 'var(--c-crimson)' : 'transparent',
              color: on ? 'var(--c-on-crimson)' : 'var(--c-text-dim)',
              font: 'inherit', letterSpacing: 'inherit', textTransform: 'inherit',
            }}
          >
            {PERSONAS[id].label}
          </button>
        );
      })}
    </div>
  );
};

export default DemoPersonaSwitch;
